import axios from 'axios'
import React from 'react'
import { baseUrl } from '../config/clientsConfig'

const FollowUpsService = {
    getFollowUpsTeams : async (body)=>{
        return axios.post(`${baseUrl}/leads/followUps-count`, body)
    },
    getFollowUpsLeads : async (body)=>{
        return axios.post(`${baseUrl}/leads/followUps`, body)
    },
    getFolloUpsDeal : async (body)=>{
        return axios.post(`${baseUrl}/deals/followUps`, body)
    },
    getFollowUpsDealTeams : async (body)=>{
        return axios.post(`${baseUrl}/deals/followUps-count`, body)
    },
    getFollowUpsUser : async (body)=>{
        return axios.post(`${baseUrl}/leads/bod-followUps-count`, body)
    },
    getFollowUpsDealsUser : async (body)=>{
        return axios.post(`${baseUrl}/deals/followUps-count-bod`, body)
    }
   
    
}

export default FollowUpsService